// extracted by mini-css-extract-plugin
export default {"form-container-head-warning":"Table_form-container-head-warning__QXtVH","buttons":"Table_buttons__V1a4-"};